import React, { FC, useEffect, useState } from "react";

import { I18nextProvider } from "react-i18next";
import { useFlags, withLDProvider } from "launchdarkly-react-client-sdk";
import CategoryMoreBenefits from "containers/CategoryMoreBenefits";
import InstBenefitsJuntar from "containers/InstBenefitsJuntar";
import InstBenefitsEmpresas from "containers/InstBenefitsEmpresas";
import InstBenefitsCategorias from "containers/InstBenefitsCategorias";
import InstBenefitsHome from "containers/InstBenefitsHome";

import CategoryBenefits from "./containers/CategoryBenefits";
import i18next from "./i18n/index";

let LDUser = window.location.origin;

export const getLDRelayURL = (hostname: string) => {
  let env = "";
  const smilesDomain = hostname.indexOf("smiles.com.br") > -1;

  const rx = smilesDomain ? /^(.*)\.smiles\.com\.br/g : /^(.*)\.voebiz\.com\.br/g;
  const res = rx.exec(hostname);
  if (res !== null) {
    if (res.length > 1 && res[1] && res[1].length > 3) {
      env = res[1];
    }
    env = env.replace(/portal|voebiz/g, "").replace("uat", "hml");
  }

  if (hostname === "localhost") {
    env = "-hml5";
    LDUser = "https://voebiz-uat5.smiles.com.br";
  }

  return `https://ldrelay${env}.smiles.com.br`;
};

const clientSideId = "62baf3989195871574e35e6c";
const launchDarklyURL = getLDRelayURL(window.location.hostname);

const App: FC<any> = ({ componentType }) => {
  const [loading, setLoading] = useState(true);
  const { apiDomain } = useFlags();

  const getComponent = {
    moreBenefits: <CategoryMoreBenefits />,
    benefits: <CategoryBenefits />,
    instBenefitsHome: <InstBenefitsHome />,
    instBenefitsJuntar: <InstBenefitsJuntar />,
    instBenefitsEmpresas: <InstBenefitsEmpresas />,
    instBenefitsCategorias: <InstBenefitsCategorias />,
  } as any;

  useEffect(() => {
    if (apiDomain) {
      setLoading(false);
    }
  }, [apiDomain]);

  if (loading) {
    return <div />;
  }

  return (
    <div className="vbz-lf">
      <I18nextProvider i18n={i18next}>{getComponent[componentType]}</I18nextProvider>
    </div>
  );
};

export default withLDProvider({
  clientSideID: clientSideId,
  user: { key: LDUser },
  reactOptions: {
    useCamelCaseFlagKeys: false,
  },
  options: {
    baseUrl: launchDarklyURL,
  },
})(App) as FC<any>;

App.defaultProps = {
  componentType: "moreBenefits",
};
